var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    stroke: "#B4975A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4975A",
    d: "M17.536 9.05s.127 1.093.127 2.186v1.025c0 1.093-.127 2.186-.127 2.186s-.123.93-.503 1.34c-.482.537-1.021.54-1.269.572-1.772.136-4.433.141-4.433.141s-3.292-.032-4.305-.136c-.282-.056-.914-.04-1.396-.577-.38-.41-.503-1.341-.503-1.341S5 13.354 5 12.26v-1.024c0-1.093.127-2.186.127-2.186s.124-.931.503-1.341c.482-.538 1.021-.541 1.268-.572C8.67 7 11.328 7 11.328 7h.006s2.658 0 4.43.137c.248.03.787.034 1.269.572.38.41.503 1.341.503 1.341zm-7.786.325v4.75l3.958-2.375L9.75 9.375z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b7f753f0dd8a9ba9b148a94495b69de6.svg";
export { ForwardRef as ReactComponent };